<template>
  <div>
    <loadingCube v-if="!loading_worker" :loadingMessage="'NEWS ARTICLE'"></loadingCube>
    <div class="row">
      <div class="col-12">
        <ValidationObserver ref="createNewsArticleForm" slim tag="div">
          <form role="form" @submit.prevent="create_news_article_submit" class="row" autocomplete="off">
            <!-- News Information -->
            <div class="col-12">
              <b-card header="Create News" header-tag="h4" body-class="mb-3 pb-2">
                <div class="row">
                  <!-- Title -->
                  <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Title" tag="div"
                    class="col-xl-6 form-group">
                    <label class="form-label" for="news_title">Title</label>
                    <input type="text" v-model="news.title" id="news_title" name="title"
                      class="form-input requiredField" :class="classes" maxlength="255">
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>

                  <!-- Category -->
                  <ValidationProvider rules="required" v-slot="{ dirty, errors, classes }" name="Category" tag="div"
                    class="col-xl-6 form-group">
                    <label class="form-label" for="category">Category</label>
                    <multiselect v-model="ms_opts.article_category" id="category" name="category" placeholder=""
                      :options="ms_opts.categories" :class="classes" label="value" track-by="id"></multiselect>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>

                  <!-- Content -->
                  <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Content" tag="div"
                    class="col-12 form-group">
                    <label class="form-label" for="content">Content</label>
                    <Editor v-model="news.content" id="content" name="content" class="form-input requiredField"
                      :class="classes" rows="6" api-key="hyqedeskz2k2mylsbkhi8wjlpkdjapoxf0a038m8402qv96x"
                      :init="editorInit" />

                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </b-card>
            </div>

            <!-- Submit Button -->
            <div class="col-12">
              <button type="submit" class="btn orcaBtn w-100">Create News Article</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <!-- <div class="col-6">
        <b-card header="Preview News Article" header-tag="h4" body-class="mb-3 pb-2">
          <div id="preview_news_article">Preview will appear here...</div>
        </b-card>
      </div> -->
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import Multiselect from 'vue-multiselect';
import Editor from '@tinymce/tinymce-vue';

export default {
  components: {
    loadingCube,
    Multiselect,
    Editor,
  },
  data() {
    return {
      loading_worker: false,
      news: {
        title: '',
        article_category_id: null,
        content: ''
      },
      ms_opts: {
        categories: [],
        article_category: null
      },
      editorInit: {
        height: 500,
        menubar: false,
        plugins: 'advlist autolink lists link image charmap print preview anchor paste',
        toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
        paste_preprocess: (plugin, args) => {
          args.content = args.content
            .replace(/[\u2018\u2019]/g, "'")     // smart single quotes
            .replace(/[\u201C\u201D]/g, '"')     // smart double quotes
            .replace(/\u00A0/g, ' ')             // non-breaking space
            .replace(/…/g, '...')                // ellipsis
            .replace(/[^\x20-\x7E\n\r]/g, '');   // remove non-printable ASCII
        }
      }
    };
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'crm/attributes/news_article_category').then(res => {
      this.ms_opts.categories = res.data;
      this.loading_worker = true;
    });
  },

  methods: {
    /**
     * Submit creation of news_article form
     * ------------------------------------
     */
    create_news_article_submit() {
      this.$refs.createNewsArticleForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.createNewsArticleForm);
        } else {
          this.saving = true;

          this.news.article_category_id = this.ms_opts.article_category.id;
          this.news.author_id = this.$store.state.auth.me.id;
          axios.post(this.crmApiPath + 'news', this.news).then(response => {
            this.$snotify.success('News Article Created');

            axios.patch(this.crmApiPath + 'news/website/save/' + response.data)
              .then(() => {
                this.$snotify.success('News Article Updated on web');
                this.handlePostUpdate();
              })
              .catch(error => {
                console.log(error);
                this.$snotify.error('Error updating news article');
                this.saving = false;
              });


            // Redirect or reset form as necessary
            this.resetForm();


            // this.$store.commit('CURRENT_EDIT_NEWS_ARTICLE_ID', this.news.id);
            // this.$store.commit('SET_WORKER_TAB_INDEX', 0);
            this.$tabs.close({ path: this.$router.currentRoute.fullPath, to: '/news/all' });
            this.$tabs.refresh('/news/all', true);
            this.$bus.$emit('logs::reload', { action: true });
            this.$bus.$emit('table::reload', { table: 'all_news', type: 'store' });



            // this.$store.commit('ADD_NEWS_ARTICLE', response.data);
            // this.$bus.$emit('logs::reload', { action: true });
            // this.$bus.$emit('table::reload', { table: 'all_news', type: 'store' });
          }).catch(error => {
            this.$snotify.error('Error creating news article');
            console.log(error);
            this.saving = false;
          });
        }
      });
    },
    resetForm() {
      this.news = {
        title: '',
        article_category_id: null,
        content: ''
      };
      this.$refs.createNewsArticleForm.reset();
    },
    handlePostUpdate() {
      this.$store.commit('CURRENT_EDIT_NEWS_ARTICLE_ID', this.news.id);
      this.$store.commit('SET_WORKER_TAB_INDEX', 0);
      this.$tabs.close({ path: this.$router.currentRoute.fullPath, to: '/news/all' });
      this.$tabs.refresh('/news/all', true);
      this.$bus.$emit('logs::reload', { action: true });
      this.$bus.$emit('table::reload', { table: 'all_news', type: 'store' });
      this.saving = false;
    }
  }
};
</script>

<style scoped lang="scss">
.vvERROR {
  color: red;
  font-size: 0.9em;
}
</style>
